import StartingEquipmentRuleSlot from './StartingEquipmentRuleSlot';

export default StartingEquipmentRuleSlot;
export { StartingEquipmentRuleSlot };
